import {Method, NetworkType} from '@/libs/wallet-connect-sdk-core/types'
import {EnvHelper} from '@/helpers/EnvHelper'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

export class XWalletConnectConfig {
  static readonly methods: Method[] = ['eth_sendTransaction']

  static networkFor(network: TWalletNetwork): NetworkType {
    const chainId = Number(EnvHelper.bridgeEnv(network).xChainId)

    return (Number.isFinite(chainId) && chainId > 0
      ? `eip155:${chainId}`
      : 'eip155:47763') as NetworkType
  }
}
